'use strict';

module.exports = {
    isCompanyCheckboxClicked: function () {
        var isCompanyCheckbox = $('.js-is-company-checkbox');
        isCompanyCheckbox.change(function () {
            $('.js-company-fields').toggleClass('d-none', !this.checked);

            $('.js-company-name-input').prop('required', this.checked);
        });
    }
};
